var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLinkedinLogo = function SvgLinkedinLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13138 14H0.228013V4.65144H3.13138V14ZM1.6797 3.37249C0.752443 3.37249 0 2.61881 0 1.68244C0 0.753671 0.752443 0 1.6797 0C2.60695 0 3.35939 0.753671 3.35939 1.68244C3.36699 2.61881 2.61455 3.37249 1.6797 3.37249ZM14 14H11.0966V9.45514C11.0966 8.37412 11.0814 6.97336 9.59175 6.97336C8.07926 6.97336 7.85125 8.15334 7.85125 9.3714V13.9924H4.95548V4.65144H7.73724V5.9304H7.77524C8.16287 5.19195 9.10532 4.42306 10.519 4.42306C13.4528 4.42306 14 6.35672 14 8.87656V14Z",
    fill: "#1E2A33"
  })));
};
export { SvgLinkedinLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin-logo.7cc1b63e.svg";